// extracted by mini-css-extract-plugin
module.exports = {"root":"LoaderDialog_root__Vk4h4","text":"LoaderDialog_text__oWkBM","bgWhite":"LoaderDialog_bgWhite__MCrEJ"};